import React from 'react';
import { BiData } from '@wix/da-bi/pkg/events';
import { getRecipientForComment } from '../../../utils';
import { getCommentNotificationQueue } from '../../../../Comment/utils';
import { ResourceType } from '../../../../types/resource';
import CoreBadgeList from '../../CoreBadgeList';
const CommentCoreBadgeList = ({ comment, className })=>/*#__PURE__*/ {
    var _comment_awardedBadges;
    return React.createElement(CoreBadgeList, {
        className: className,
        badges: (_comment_awardedBadges = comment.awardedBadges) !== null && _comment_awardedBadges !== void 0 ? _comment_awardedBadges : [],
        recipient: getRecipientForComment(comment),
        targetTypeId: ResourceType.DEVIATION,
        targetItemId: comment.commentId,
        notificationQueueName: getCommentNotificationQueue(comment),
        biData: BiData({
            evid: 323,
            sectionname: 'comments',
            typeid: ResourceType.COMMENT,
            itemid: comment.commentId
        }),
        size: "small"
    });
};
CommentCoreBadgeList.displayName = 'CommentCoreBadgeList';
export default CommentCoreBadgeList;
